import { shimTextEncoding } from 'utils/shimTextEncoding';
import 'core-js/actual/array/find-last-index';

export const loadShims = async () => {
  if (!window.TextDecoder) {
    await shimTextEncoding();
  }
};
